// extracted by mini-css-extract-plugin
export var about = "About-module--about--807IG";
export var aboutMeContainer = "About-module--aboutMeContainer--1b1x2";
export var aboutPhoto = "About-module--aboutPhoto--1BTEd";
export var aboutText = "About-module--aboutText--1ZlfK";
export var techStack = "About-module--techStack--1NsJW";